import React from "react"

function IconComputerArrowUpTimes({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="computer-arrow-up-times"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-computer-arrow-up-times"
      {...props}
    >
      <path
        d="M15.8 20.037a.655.655 0 0 1 .106 1.3l-.106.01H8.25a.655.655 0 0 1-.106-1.301l.106-.009H15.8zm.62-17.364c.073.321.22.629.441.896l.142.156.258.258H2.668a.43.43 0 0 0-.422.343l-.009.087v12.363a.43.43 0 0 0 .344.422l.087.009h18.713c.21 0 .384-.148.424-.344l.008-.087V8.433c.4.233.86.328 1.309.284v8.059a1.74 1.74 0 0 1-1.582 1.733l-.159.007H2.668a1.74 1.74 0 0 1-1.733-1.582l-.007-.158V4.413A1.74 1.74 0 0 1 2.51 2.681l.158-.008h13.751zm-3.953 4.97c.093.059.17.137.23.229l2.965 4.612a.764.764 0 0 1-.643 1.177H9.09a.764.764 0 0 1-.642-1.177l2.965-4.612a.764.764 0 0 1 1.055-.23zm6.45-6 .091.076 1.72 1.718 1.718-1.718a.655.655 0 0 1 1.002.835l-.076.09-1.719 1.72 1.719 1.719a.655.655 0 0 1-.835 1.001l-.09-.076-1.72-1.718-1.719 1.718a.655.655 0 0 1-1.001-.835l.076-.09 1.718-1.72-1.718-1.718a.655.655 0 0 1 .835-1.002z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconComputerArrowUpTimes
